<template lang="pug">
.tour-button(@click="startTour")
  span {{ $t('ratingBar.tour') }}
  i(class="pi pi-info-circle")
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { useSettings } from "@/store";
import { storeToRefs } from "pinia";

export default defineComponent({
  name: "TourButton",
  setup() {
    const router = useRouter();
    const settingsStore = useSettings();
    const { initializeTour } = settingsStore;
    const { tour } = storeToRefs(settingsStore);
    async function startTour() {
      await router.replace("/recommendations");
      if (!tour.value) {
        initializeTour();
      }
      setTimeout(() => tour.value.start(), 250);
    }
    return {
      startTour,
    };
  },
});
</script>
<style lang="scss">
.tour-button {
  height: 1.5rem;
  max-width: 6rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.8rem;
  padding: 0 0.25rem 0 0.7rem;
  border-radius: 1rem;
  background-color: #e2e2e2;
  cursor: pointer;
  &:hover {
    background-color: #cacaca;
  }
  i {
    color: $primary-color;
  }
}

@media screen and (max-width: 450px) {
  .tour-button {
    padding: 0px 0.4rem !important;
    span {
      display: none;
    }
  }
}
</style>
